import { QueryInputType, queryInput } from '@/utils';

import { QuestionnaireQuestionConnectionInput } from '@/models/gen/graphql';
import { SearchQuestionnaireQuestionDocument } from '@/api/queries';
import graphApi from '@/api';

const [, runRefetchQuestionnaireQuestion] = graphApi(SearchQuestionnaireQuestionDocument);
const PAGE_SIZE = 1000;

export const searchQuestions = async (categoryIds?: string[], text?: string) => {
  const input: QuestionnaireQuestionConnectionInput = {
    first: PAGE_SIZE,
    after: null,
    query: [
      {
        questionnaireCategoryId: categoryIds?.length ? queryInput(categoryIds) : undefined,
        active: queryInput(1),
      },
    ],
  };

  if (text) {
    input.query = [
      {
        questionnaireCategoryId: categoryIds?.length ? queryInput(categoryIds) : undefined,
        active: queryInput(1),
        questionText: queryInput(`%${text}%`, QueryInputType.LIKE),
      },
      {
        questionnaireCategoryId: categoryIds?.length ? queryInput(categoryIds) : undefined,
        active: queryInput(1),
        helperText: queryInput(`%${text}%`, QueryInputType.LIKE),
      },
    ];
  }

  return await runRefetchQuestionnaireQuestion({ input });
};

export const searchQuestionsWithMetadata = async (categoryIds?: string[], text?: string) => {
  if (!categoryIds?.length) {
    return {
      questions: [],
      totalCount: 0,
    };
  }
  const res = await searchQuestions(categoryIds, text);

  return {
    questions: res?.searchQuestionnaireQuestion?.questionnaireQuestionConnection?.edges
      ?.map((edge) => edge?.node)
      .filter((node) => Boolean(node)),
    totalCount: res?.searchQuestionnaireQuestion?.questionnaireQuestionConnection?.totalCount,
  };
};

// Builds a categoryId -> question count map, so a category grid can show item counts without a
// separate query per category. Uses searchQuestions directly (not searchQuestionsWithMetadata,
// which short-circuits to an empty result when no categoryIds are passed).
export const getQuestionCountsByCategory = async (): Promise<Record<string, number>> => {
  const res = await searchQuestions();
  const questions = res?.searchQuestionnaireQuestion?.questionnaireQuestionConnection?.edges
    ?.map((edge) => edge?.node)
    .filter((node) => Boolean(node));

  return (questions || []).reduce((counts: Record<string, number>, question) => {
    counts[question.questionnaireCategoryId] = (counts[question.questionnaireCategoryId] || 0) + 1;
    return counts;
  }, {});
};
